import { MAX_CARTAGE_PAY_PAYOUT_CENTS } from "@/utils/cartagePayAmount.utils"

export const WALLET_FUND_PARAM = "fund"

export const walletFundPath = (fundCents: number | null): string =>
    fundCents && fundCents > 0
        ? `/?w=cartagePay&tab=funding&${WALLET_FUND_PARAM}=${Math.round(fundCents)}`
        : "/?w=cartagePay"

export const parseFundCents = (value: unknown): number | null => {
    if (typeof value !== "string" || !/^\d{1,12}$/.test(value)) return null
    const cents = Number(value)
    return cents > 0 && cents <= MAX_CARTAGE_PAY_PAYOUT_CENTS ? cents : null
}
